import CenterDiv from "./layouts/CenterDiv";
import Loading from "./Loading";

const LoadingCenter = () => {
  return <CenterDiv>
    <Loading />
  </CenterDiv>;
};

export default LoadingCenter;